import "./Home.module.css";
import CabeceraPrincipal from "@/reusable_sections/Header";
import ReinventandoElTransporteEnResorts from "./sections/ReinventandoElTransporteEnResorts";
import LaTransformaciNDelServicio from "./sections/LaTransformaciNDelServicio";
import VisibilidadTotalEn3Niveles from "./sections/VisibilidadTotalEn3Niveles";
import CMoFuncionaElEcosistema from "./sections/CMoFuncionaElEcosistema";
import ImpactoEnLaExperiencia from "./sections/ImpactoEnLaExperiencia";
import Operationalimpactanalysis from "./sections/Operationalimpactanalysis";
import Beneficios from "./sections/Beneficios";
import Casopracticoworkflow from "./sections/Casopracticoworkflow";
import PieDePGinaInformativo from "@/reusable_sections/Footer";
import Highimpactconversioncta from "./sections/Highimpactconversioncta";
export default function HomePage() {
  return <div>
      <CabeceraPrincipal />
      <ReinventandoElTransporteEnResorts />
      <Operationalimpactanalysis />
      <LaTransformaciNDelServicio />
      <VisibilidadTotalEn3Niveles />
      <Beneficios />
      <Casopracticoworkflow />
      <Highimpactconversioncta />
      <CMoFuncionaElEcosistema />
      <ImpactoEnLaExperiencia />
      <PieDePGinaInformativo />
    </div>;
}